import classNames from 'clsx';
import React, { type FC } from 'react';
import { NameComponent } from 'reactApp/ui/Name/Name';

import styles from './NoAccessItem.css';

interface NoAccessItemProps {
    hideName?: boolean;
    hideTooltip?: boolean;
    centered?: boolean;
}

export const NoAccessItem: FC<NoAccessItemProps> = ({ centered, hideName, hideTooltip = false }) => {
    return (
        <div className={classNames(styles.root, { [styles.centered]: centered, [styles.hidden]: hideName })}>
            <NameComponent name="Файл недоступен" showTooltip={!hideTooltip} truncate />
        </div>
    );
};
